import {
  getCategWithFiltersAndProductsError, getCategWithFiltersAndProductsSuccess,
  getExclusiveCellarProducts,
  updateCategFilters, updateCategFiltersError, updateCategFiltersSuccess
} from '../slices/categ.slice';
import { parseFilters } from '@/utils/categUtils';
import { AppListenerEntry } from '..';
import { PAGE_SIZE } from '@/constants/categ';
import { STORE_ID_DEFAULT } from '@/constants/stores';

export const epicUpdateCategFilters: AppListenerEntry = {
  actionCreator: updateCategFilters,
  effect: async (_action: ReturnType<typeof updateCategFilters>, { getState, dispatch, extra: { productsService } }) => {
    const { auth, root, categ } = getState();
    const { storeId = STORE_ID_DEFAULT } = root.storeConf;
    const { categId, filterQuery } = categ;
    const { page, sort, searchTerm, isCategViewWB } = categ.content;
    const { loggedUser } = auth;

    if (searchTerm) {
      try {
        const result = await productsService.getSearchProducts(
          { storeId, searchTerm, page, size: PAGE_SIZE.LIST, filter: filterQuery, sort, ec: !!loggedUser?.isEc }
        ) as any;
        dispatch(updateCategFiltersSuccess({ content: {
          ...result,
          filters: result.filters ? parseFilters(result.filters, filterQuery, storeId) : []
        } }));
      } catch (error) {
        dispatch(updateCategFiltersError({ error }));
      }
    } else {
      try {
        const result = await productsService.getCategWithFiltersAndProducts({
          storeId, categ: categId, page, size: PAGE_SIZE.LIST, filter: filterQuery, sort, isCategViewWB
        }, !!loggedUser?.isEc) as any;

        dispatch(getCategWithFiltersAndProductsSuccess({
          content: {
            ...result.categ,
            top: result.top,
            filters: parseFilters(result.filters, filterQuery, storeId),
            products: result.products,
            nbTotalRows: result?.nbTotalRows,
            sortOrder: result?.sortOrder
          }
        }));
      } catch (error) {
        dispatch(getCategWithFiltersAndProductsError({ error }));
      }
    }
  }
};

export const epicGetExclusiveCellarProducts: AppListenerEntry = {
  actionCreator: getExclusiveCellarProducts,
  effect: async (_action: ReturnType<typeof getExclusiveCellarProducts>, { getState, dispatch }) => {
    const { auth } = getState();
    if (auth.loggedUser.isEc) {
      dispatch(updateCategFilters());
    }
  }
};
